export let InfluenceValue = {
  label: '',
  influence: 0
}
export let InfluenceResult = {
  name: '',
  value: Array
}
export let Influences = {
  classes: Array,
  importance: Array,
  importanceX: Array,
  weight: Array,
  removed: {}
}



// WEBPACK FOOTER //
// ./src/defines/model/influence.js